import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { resturlConstants } from '../../../rest-url/resturlconstants';
import { environment } from '../../../environments/environment';
import { HomeService } from '../../home/home.service';

@Injectable()
export class FixedDepositsService {

  constructor(private http: HttpClient, private homeService: HomeService) { }

  fixedDepositData(): Observable<any> {
    return this.http.post<any>(resturlConstants.FDUrl, {
      'userId': localStorage.getItem('userId'),
      'clientShortCode': environment.clientShortCode
    },
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
          .set('Authorization', this.homeService.getAuthHeader())
      }
    );
  }

}

